// extracted by mini-css-extract-plugin
export default {"cartItemAttributes":"cartItemAttributes__ZTM2M","label":"label__OWY3M","value":"value__ZWI5Z","noTextTransform":"noTextTransform__MDdkM"};